import { Pipe, PipeTransform } from '@angular/core';
import { MdAction } from '@macs-frontend/web-macs/shared';
import { ActionConfirmationStatuses } from '../../public/action/action-confirmation/models/action-confirmation-statuses';

@Pipe({ name: 'actionConfirmationStatus' })
export class ActionConfirmationStatusPipe implements PipeTransform {
  public transform(action?: MdAction): any {
    if (!action) {
      return '';
    }

    if (!action.confirmationStatus) {
      return 'Waiting for confirmation';
    }

    switch (action.confirmationStatus) {
      case ActionConfirmationStatuses.ACTION_CONFIRMED:
        return 'Action confirmed by ' + action.confirmedBy;
      case ActionConfirmationStatuses.MATERIALS_READY:
        return 'Materials ready by ' + action.confirmedBy;
      case ActionConfirmationStatuses.ACTION_READY:
        return 'Action ready by ' + action.confirmedBy;
    }
  }
}
